export function GetAppToken(state) {
    return state.StreamingReducer.appToken;
}

export function GetRoomDetails(state) {
    return state.StreamingReducer.room;
}

export function GetSessionDetails(state) {
    return state.StreamingReducer.sessions;
}
